import React from 'react';
import { Tooltip } from '@here/hds-tooltip';
// eslint-disable-next-line no-new
new Tooltip();
const HDSTooltip = React.forwardRef((props, ref) => {
    const { placement, children, interactive, trigger, triggerBy, disabled, className, ...rest } = props;
    return (React.createElement("hds-tooltip", { ref: ref, ...(placement && { placement }), ...(className && { class: className }), ...(interactive && { interactive }), ...(triggerBy && { 'trigger-by': triggerBy }), ...(trigger && { trigger }), ...(disabled && { disabled }), ...rest },
        React.createElement("div", null, children)));
});
HDSTooltip.defaultProps = {
    id: '',
    disabled: false,
    placement: 'top',
    interactive: false,
    trigger: 'mouseenter focus',
};
export default HDSTooltip;
//# sourceMappingURL=HDSTooltip.js.map